import { API_URL } from '../config/api';

export const getFeedbacks = async (token) => {
  const response = await fetch(`${API_URL}/api/feedbacks?populate=*`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error('Failed to fetch feedbacks');
  const result = await response.json();
  return result.data ?? result;
};

export const fetchAllFeedbacks = getFeedbacks;

export const createFeedback = async (feedbackData, token) => {
  const response = await fetch(`${API_URL}/api/feedbacks`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ data: feedbackData }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error?.message || 'Failed to submit feedback');
  }
  return response.json();
};

export const updateFeedback = async (feedbackId, feedbackData, token) => {
  const response = await fetch(`${API_URL}/api/feedbacks/${feedbackId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ data: feedbackData }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error?.message || 'Failed to update feedback');
  }
  const result = await response.json();
  return result.data ?? result;
};

export const deleteFeedback = async (feedbackId, token) => {
  const response = await fetch(`${API_URL}/api/feedbacks/${feedbackId}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error('Failed to delete feedback');
  return response.json();
};

// Optional default export for backwards compatibility
export const feedbackApi = {
  getFeedbacks,
  fetchAllFeedbacks,
  createFeedback,
  updateFeedback,
  deleteFeedback,
};